function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as UserApi from "../ajax/UserApi";
import IntlMessage from '../commons/Intl';
import { Action, Password, Description } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ユーザーパスワードリセットモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示
   */

  Mode[Mode["Send"] = 1] = "Send";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Send:
        _this.state = {
          Modal: null,
          UserId: _this.props.userId,
          UserName: _this.props.userName,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    _this.GetThumbnailUrl();

    return _this;
  }

  _createClass(MainComponent, [{
    key: "GetThumbnailUrl",
    value: function GetThumbnailUrl() {
      if (!this.props.userId || !this.props.thumbnailFileName) {
        return;
      }

      UserApi.GetThumbnail(this.state.UserId, this.props.thumbnailFileName, function (blob) {
        $("#userthumbnailmodaliconframe").css("background-image", 'url(' + window.URL.createObjectURL(blob) + ')');
        var thumbnailFrame = $("#thumbnailframe");
        thumbnailFrame.css("background-image", 'none');
      });
    }
    /**
     * 「送信」ボタン押下時の処理を行います。
     */

  }, {
    key: "onSend",
    value: function onSend() {
      if (this.state.Modal == null || !this.props.userId) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.props.userId) {
          throw Error();
        }

        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onSend(this.props.userId);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#UserModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modalIcon"
      }, /*#__PURE__*/React.createElement("div", {
        id: "userthumbnailmodaliconframe",
        className: "thumbnailicon40frame"
      })), /*#__PURE__*/React.createElement("h3", null, intl.format(Password.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto",
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-9"
      }, intl.format(Description.ActionDescriptionResetPassword, {
        name: this.state.UserName
      })))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        key: "onSend",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onSend.bind(this),
        tabIndex: -1
      }, intl.format(Action.Reset)), ","))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };